import validationsJson from '@/data/json/errors/validations.json'

export const fieldValidationsMixin = {
  computed: {
    fieldNeccessary() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.required &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'field_neccessary'
          )
        )
        return errors
      }
    },
    emailInvalid() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.email &&
        errors.push(
          this.$cmsService.getContent(validationsJson.data, 'email_invalid')
        )
        return errors
      }
    },
    minLength() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.minLength &&
        errors.push(
          this.$cms.get(validationsJson.data, 'min_length', {
            '{MIN_VALUE}': fieldObj.$params.minLength.min
          })
        )
        return errors
      }
    },
    password() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.minLength &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'password_min_length'
          )
        )
        !fieldObj.hasCapital &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'password_capital_letter_necessary'
          )
        )
        !fieldObj.hasNum &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'password_number_necessary'
          )
        )
        !fieldObj.hasSpecialChar &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'password_special_char_necessary'
          )
        )
        return errors
      }
    },
    passwordRepeat() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.sameAs &&
        errors.push(
          this.$cmsService.getContent(
            validationsJson.data,
            'passwords_not_identical'
          )
        )
        return errors
      }
    },
    checkbox() {
      return (checkbox, v) => {
        const errors = []
        let checkboxObj = typeof checkbox === 'boolean' ? v[checkbox] : checkbox
        if (!checkboxObj.$dirty) return errors
        !checkboxObj.checked &&
        errors.push(
          this.$cmsService.getContent(validationsJson.data, 'checked_consent')
        )
        return errors
      }
    },
    zipCodeErrors() {
      return (field, v) => {
        const errors = []
        let fieldObj = typeof field === 'string' ? v[field] : field
        if (!fieldObj.$dirty) return errors
        !fieldObj.onlyDigits &&
        errors.push(
          this.$cmsService.getContent(validationsJson.data, 'zipcode_numeric')
        )
        !fieldObj.correctLength &&
        errors.push(
          this.$cmsService.getContent(validationsJson.data, 'zipcode_size')
        )
        return errors
      }
    },
    taxIdErrors() {
      return (field, v) => {
        const errors = []
        if (v.required) {
          let fieldObj = typeof field === 'string' ? v[field] : field
          if (!fieldObj.$dirty) return errors
          !fieldObj.hasGermanCountryCode &&
          errors.push(
            this.$cmsService.getContent(
              validationsJson.data,
              'invalid_tax_id_country_code'
            )
          )
          !fieldObj.hasUniqueNumbers &&
          errors.push(
            this.$cmsService.getContent(validationsJson.data, 'invalid_tax_id')
          )
          !fieldObj.isGermanTaxId &&
          errors.push(
            this.$cmsService.getContent(validationsJson.data, 'invalid_tax_id')
          )
        }
        return errors
      }
    }
  }
}
